export default "<p>kundengruppe-gruppen-zuweisung works!</p>\r\n";